import {
    ComponentFactoryResolver,
    ComponentRef,
    Directive,
    ElementRef,
    HostListener,
    Injector,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { ContenteditableModelDirective } from '@fi-shared/contenteditable-model/contenteditable-model.directive';
import { FiContenteditableSimpleTextPanelRootDirective } from './fi-contenteditable-simple-text-panel-root.directive';
import {
    DocumentEditItemSimpleTextPanelComponent,
    DocumentEditItemSimpleTextPanelComponentData,
} from '@fi-app/document/edit-item/simple-text-panel/simple-text-panel.component';
import { eventFindInPath } from '@fi-shared/utils';
import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

let idx = 0;

@Directive({
    selector: '[fi-contenteditable-simple-text-panel-handler]',
    providers: [
        {
            provide: DocumentEditItemSimpleTextPanelComponentData,
            useFactory: (
                contenteditableSimpleTextPanelHandlerDirective: FiContenteditableSimpleTextPanelHandlerDirective,
            ) => {
                return {
                    closeInsertMediaDialogAfterFileSelection:
                        contenteditableSimpleTextPanelHandlerDirective.contenteditableModelDirective
                            .closeInsertMediaDialogAfterFileSelection,
                };
            },
            deps: [FiContenteditableSimpleTextPanelHandlerDirective],
        },
    ],
    standalone: false,
})
export class FiContenteditableSimpleTextPanelHandlerDirective implements OnInit, OnDestroy {
    idx = ++idx;
    @Input() fiContentedtableSimpleTextPanelIsInsertFileShown: boolean = true;
    constructor(
        private elementRef: ElementRef,
        public contenteditableModelDirective: ContenteditableModelDirective,
        private fiContenteditableSimpleTextPanelRoot: FiContenteditableSimpleTextPanelRootDirective,
        private cfr: ComponentFactoryResolver,
        private injector: Injector,
        private fiBrowserEventsService: FiBrowserEventsService,
    ) {}

    ngOnInit(): void {
        this.fiBrowserEventsService
            .getDocumentEventSubject$('click')
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((event: MouseEvent) => this.onDocumentClick(event));
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.removePanel();
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    panel: ComponentRef<DocumentEditItemSimpleTextPanelComponent>;

    private checkOpenPanel() {
        // https://chainformation.atlassian.net/browse/FI-2756
        if (this.panel) return;

        this.panel = this.fiContenteditableSimpleTextPanelRoot.currentViewContainerRef.createComponent(
            this.cfr.resolveComponentFactory(DocumentEditItemSimpleTextPanelComponent),
            undefined,
            this.injector,
        );
        this.panel.instance.isInsertMediaButtonShown = this.fiContentedtableSimpleTextPanelIsInsertFileShown;
    }

    @HostListener('focus')
    onFocus() {
        if (!this.mouseDownOnText) this.checkOpenPanel();
    }

    private removePanel() {
        this.fiContenteditableSimpleTextPanelRoot.currentViewContainerRef.clear();
        this.panel = undefined;
    }

    private mouseDownOnText: boolean = false;

    @HostListener('mousedown')
    onMouseDown() {
        this.mouseDownOnText = true;
    }

    onDocumentClick(event: Event) {
        if (this.mouseDownOnText) {
            setTimeout(() => {
                this.mouseDownOnText = false;
                this.checkOpenPanel();
            });
        }

        if (
            !this.panel ||
            this.mouseDownOnText ||
            this.panel.instance.elementRef.nativeElement.contains(event.target) ||
            this.elementRef.nativeElement.contains(event.target) ||
            eventFindInPath(event, '.operation-overlay-small') || // todo clear this after remove all operation overlay's
            eventFindInPath(event, '.operation-overlay-large') || // todo clear this after remove all operation overlay's
            eventFindInPath(event, '.mat-dialog-container')
        )
            return;

        this.removePanel();
    }
}
